import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { RamblaSpinner } from 'components';
import { DASHBOARD } from 'constants/routes';
import { useNavigate } from 'react-router';
import { useAuthStore } from 'stores/authStore';
import { useUserTourStore } from 'stores/userTourStore';
import { removeCurrentOnboardingStep } from 'utils/tokenService';
import { ReactComponent as Icon } from '../../assets/img/illustrations/splash.svg';

const OnboardingFinalSplashPage = () => {
  const { t } = useTranslation(['pages']);
  const navigate = useNavigate();
  const adminUid = useAuthStore((state) => state.user?.admin_details?.uid);
  const scheduleTour = useUserTourStore((state) => state.scheduleTour);

  useEffect(() => {
    const timer = setTimeout(() => {
      removeCurrentOnboardingStep(adminUid);
      scheduleTour();
      navigate(DASHBOARD);
    }, 3000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h1 className="display-4 text-center">{t('onboarding.splashTitle')}</h1>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div
          style={{
            maxWidth: '600px',
            maxHeight: '600px',
            width: '100%',
            position: 'relative',
            marginTop: '1rem',
          }}
        >
          <div
            style={{
              top: 0,
              left: 0,
              width: '100%',
            }}
          >
            <Icon />
            <RamblaSpinner
              style={{
                position: 'absolute',
                top: '33%',
                left: '41%',
                transform: 'translate(-50%,-50%)',
                maxWidth: '30px',
                maxHeight: '20px',
              }}
            />
          </div>
        </div>
      </div>
      <h4 className="text-muted text-center">{t('onboarding.splashSubtitle')}</h4>
    </>
  );
};

export default OnboardingFinalSplashPage;
